import React from 'react';
import { Squares2X2Icon, ListBulletIcon } from '@heroicons/react/24/outline';

const IssueView = ({ view, onViewChange, issueCount }) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {issueCount} issue{issueCount !== 1 ? 's' : ''}
        </span>
      </div>
      
      <div className="flex items-center space-x-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
        <button
          onClick={() => onViewChange('list')}
          className={`p-2 rounded-md transition-colors ${
            view === 'list' 
              ? 'bg-white dark:bg-gray-600 shadow-sm' 
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
          }`}
        >
          <ListBulletIcon className="h-4 w-4" />
        </button>
        
        <button
          onClick={() => onViewChange('kanban')}
          className={`p-2 rounded-md transition-colors ${
            view === 'kanban' 
              ? 'bg-white dark:bg-gray-600 shadow-sm' 
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
          }`}
        >
          <Squares2X2Icon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default IssueView;